import React from "react";
import { Row, Col, Typography, Form, Input, Button, Space } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import api from "../../api/Api";
import axios from "axios";
import { AxiosRequestConfig } from "axios";
import { getEnvVars } from "../../Environment";
const { oAuthConfig } = getEnvVars();

const LoginCallBack: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  React.useEffect(() => {
    let code = params.get("code");
    let state = params.get("state");
    let qs = require("qs");
    let data = qs.stringify({
      grant_type: oAuthConfig.grantType,
      code: code,
      client_id: oAuthConfig.clientId,
      // code_verifier: state,
      client_secret : oAuthConfig.clientSecret,
      redirect_uri: oAuthConfig.recirect,
    });
    let config = {
      method: "post",
      url: `${getEnvVars().apiUrl}/connect/token`,
      headers: {},
      data: data,
    } as AxiosRequestConfig;

    axios(config)
      .then(function (response: any) {
        localStorage.setItem("access_token", response.data.access_token);
        window.location.href = "/panel";
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <div>
      <h3>logging in...</h3>
    </div>
  );
};
export default LoginCallBack;
